// Scripts for the homepage demos, keyed by data-demo. Each gets the demo
// (`d`) and runs one loop; the demo resets the screen between loops. Markup
// lives in app/views/welcome/demos/.

export default {
  // Inbox → course chat → react → reply with an @mention → teacher replies.
  async chat(d) {
    await d.wait(900)
    await d.clickOn('room-va101')
    d.set('view', 'room')
    d.url('closingcredits.com/chats/voice-acting-101')
    await d.wait(1000)
    await d.move('msg-bella', { dx: -40 })
    await d.wait(500)
    await d.clickOn('react-add')
    d.set('picker', 'on')
    await d.wait(400)
    await d.clickOn('emoji-fire')
    d.unset('picker')
    d.set('fire', 'on')
    await d.wait(700)
    await d.move('msg-bella', { dx: -40 })
    await d.clickOn('reply')
    d.set('replying', 'on')
    await d.wait(300)
    await d.clickOn('composer')
    await d.type('[data-field="at"]', '@bel', { ms: 90 })
    d.set('at', 'on')
    await d.wait(500)
    await d.clickOn('mention-bella')
    d.unset('at')
    d.set('mentioned', 'on')
    await d.type('[data-field="msg"]', ' it lands! Grab a breath before "sleep" and it\'s perfect.', { ms: 35 })
    await d.wait(300)
    await d.clickOn('send')
    d.set('sent', 'on')
    d.find('[data-field="msg"]').textContent = ''
    await d.wait(1600)
    d.set('jamil', 'on')
    await d.wait(3000)
  },

  // Courses → class sessions → events → RSVP.
  async dashboard(d) {
    await d.wait(1200)
    await d.move('course-0', { dy: -10 })
    await d.wait(900)
    await d.move('course-1', { dy: -10 })
    await d.wait(900)
    await d.scrollTo('sessions')
    await d.wait(1400)
    await d.scrollTo('events')
    await d.wait(600)
    await d.clickOn('attend')
    d.set('attending', 'on')
    await d.wait(3200)
  },

  // Course → Session 1 event → recording + chapter → homework link.
  async courses(d) {
    await d.wait(1000)
    await d.clickOn('session-1')
    d.set('view', 'event')
    d.url('closingcredits.com/events/4496-voice-acting-101-session-1')
    await d.wait(1200)
    await d.clickOn('watch')
    await d.scrollTo('recording')
    await d.clickOn('play')
    d.set('playing', 'on')
    await d.wait(1800)
    await d.clickOn('chapter-5')
    d.set('chapter', 'on')
    await d.wait(1800)
    await d.scrollTo('homework-box', 80)
    await d.wait(400)
    await d.clickOn('homework')
    d.set('homework', 'on')
    await d.wait(3000)
  },
}
